<section class="flex flex-col gap-4 p-4 pb-10 rounded border">
  <h4 class="font-bold">
    {{ JobModuleTranslationKeys.DASHBOARD | translate }}
  </h4>
  <h2 class="text-5xl font-bold">
    {{ DashboardTranslateKeys.WELCOME | translate }} {{ firstname() }}
  </h2>
  <p class="max-w-xl">{{ DashboardTranslateKeys.BANNER_DESC | translate }}</p>
</section>
